import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RadioSection } from "@Shared/components/sections";
import MaterialInput from "@Shared/components/inputs/material-input";
import DocumentClassificationSelect from "@Broker/@Modules/clients/applications/documents/components/utils-components/document-classification-select";
import ClassificationSelectContainer from "@Broker/@Modules/clients/applications/documents/components/documents-page/document-classification/classification-select-container";
import { mapGetters } from "vuex";
import { DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION } from "@Broker/@Modules/clients/applications/documents/store/documents-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SelectClassificationStep",
  components: {
    MaterialInput,
    RadioSection,
    DocumentClassificationSelect,
    ClassificationSelectContainer
  },
  props: {
    applicationId: {
      type: [String, Number],
      default: ""
    },
    clientUsername: {
      type: String,
      required: true
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    selectedType: {
      type: String,
      default: ""
    },
    selectedClassification: {
      type: Object,
      default: () => ({})
    },
    currentClassification: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      typeOptions: [{
        label: this.$t("documents.useExistingClassification"),
        value: "use-existing"
      }, {
        label: this.$t("documents.createNewClassification"),
        value: "create-new"
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("DocumentsStore", [DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION])), {}, {
    computedSelectedType: {
      get() {
        return this.selectedType;
      },
      set(value) {
        this.$emit("update:selectedType", value);
      }
    },
    selectedClassificationValue() {
      var _this$selectedClassif;
      return ((_this$selectedClassif = this.selectedClassification) == null ? void 0 : _this$selectedClassif.id) || null;
    },
    classifications() {
      var _context;
      return _filterInstanceProperty(_context = _Object$values(this.DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION(this.applicationId).byId)).call(_context, item => item.documentRequestId != this.currentClassification);
    },
    isSelectedTypeUseExisting() {
      return this.computedSelectedType === "use-existing";
    }
  }),
  watch: {
    selectedType() {
      this.handleClassificationChange({});
    }
  },
  methods: {
    handleClassificationChange(event) {
      this.$emit("change", event);
    }
  }
});